import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from '../ui/Button';
import { HERO_BENEFITS, OFFERS_ANCHOR, PRICE } from '../../data/offer';
export function Hero() {
  return <header className="bg-cream" data-id="element-65" data-mp="cv2yjgw1bm8g">
      {/* Mockup premium */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="w-full bg-ink" data-id="element-66" data-mp="hvh14jeva3z3">
        <img src="https://cdn.magicpatterns.com/uploads/96Zv7EuSXUhiEVwjVSxdq4/ChatGPT_Image_15_sept_2026,_07_31_11_p.m..png" alt="Los 6 tomos y los 6 bonos de Carpintería Plegable PRO sobre un banco de taller, junto a una notebook con planos técnicos" className="mx-auto block w-full max-w-5xl object-cover" width={1536} height={1024} data-id="element-67" data-mp="qvdv90k0zv1j" />
      </motion.div>

      <div className="mx-auto max-w-3xl px-5 pb-14 pt-8 text-center md:px-8 md:pb-20 md:pt-12" data-id="element-68" data-mp="1aito2uoxwdsx">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="font-display text-xs font-black uppercase tracking-[0.24em] text-wood-dark" data-id="element-69" data-mp="9o2rvr4dz0pp">
          Carpintería Plegable PRO™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-4 font-display text-[2.1rem] font-black uppercase leading-[1] text-ink sm:text-5xl md:text-[3.6rem]" data-id="element-70" data-mp="3rv0c29iy0ama">
          Dejá de preguntarte
          <span className="mt-2 block text-wood" data-id="element-71" data-mp="en5kgc36jegs">
            qué fabricar para vender
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink/75 md:text-lg" data-id="element-72" data-mp="1b51y4t1hclbu">
          Accedé a proyectos de muebles plegables con planos, medidas y recursos
          prácticos para fabricar, cotizar y sumar nuevos productos a tu
          catálogo.
        </motion.p>

        <ul className="mx-auto mt-7 grid max-w-xl grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-73" data-mp="2vuxjfchdg6xw">
          {HERO_BENEFITS.map(benefit => <li key={benefit} className="flex items-center gap-2 rounded-xl border border-cream-line bg-white px-3.5 py-3 text-left text-sm font-semibold text-ink md:text-[15px]" data-id="element-74" data-mp="2hueggjrrjr2l">
              <CheckIcon className="h-4 w-4 flex-shrink-0 text-cta" strokeWidth={3.5} data-id="element-75" data-mp="27z2xfp9bnxp1" />
              {benefit}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-md rounded-2xl border-2 border-gold/50 bg-white p-6 shadow-lift" data-id="element-76" data-mp="66ogotiikza7">
          <span className="inline-flex rounded-full bg-ink px-4 py-2 font-display text-[11px] font-black uppercase tracking-[0.16em] text-gold" data-id="element-77" data-mp="b2vokruh0kus">
            6 Tomos + 6 Bonos
          </span>

          <p className="mt-6 text-[10px] font-bold uppercase tracking-[0.2em] text-ink-muted" data-id="element-78" data-mp="1qpqvfwxlwn26">
            Desde
          </p>
          <p className="mt-1 font-display text-5xl font-black leading-none text-ink md:text-6xl" data-id="element-79" data-mp="20m3qoz8sv8z1">
            {PRICE.from}
          </p>
          <p className="mt-3 font-display text-[10px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-80" data-mp="2ecgwow24sdlq">
            Pago único • 100% digital • Acceso inmediato
          </p>

          <div className="mt-6" data-id="element-81" data-mp="2oc7q0ueygmk8">
            <CtaButton href={OFFERS_ANCHOR} external={false} size="xl" data-id="element-82" data-mp="2ob63ntshodn7">
              Ver las ofertas
            </CtaButton>
          </div>
        </div>
      </div>
    </header>;
}